import * as yup from 'yup';
import { bindQuotePayloadSchema, financeableTransactionSchema } from './premiumFinance';
import { AdyenPaymentMethod } from '../../types';
import { PadAgreementServiceType } from './reporting';
export const paymentMethodScheme = yup.object().shape({
    type: yup
        .mixed()
        .oneOf([
        AdyenPaymentMethod.Ach,
        AdyenPaymentMethod.Card,
        AdyenPaymentMethod.Eft,
        AdyenPaymentMethod.ApplePay,
        AdyenPaymentMethod.GooglePay,
    ])
        .required(),
    // card type
    brand: yup.string().optional(),
    encryptedCardNumber: yup.string().optional(),
    encryptedExpiryMonth: yup.string().optional(),
    encryptedExpiryYear: yup.string().optional(),
    encryptedSecurityCode: yup.string().optional(),
    holderName: yup.string().optional(),
    taxNumber: yup.string().optional(),
    // googlepay type
    googlePayCardNetwork: yup.string().optional(),
    googlePayToken: yup.string().optional(),
    // ach type
    encryptedBankAccountNumber: yup.string().optional(),
    encryptedBankLocationId: yup.string().optional(),
    ownerName: yup.string().optional(),
    // eft
    bankAccountNumber: yup.string().optional(),
    bankLocationId: yup.string().optional(),
    bankCode: yup.string().optional(),
    // ownerName: see ach type above
    // stored method
    storedPaymentMethodId: yup.string().optional(),
    checkoutAttemptId: yup.string().optional(),
    // apple pay
    applePayToken: yup.string().optional(),
});
export const completePaymentSchema = yup
    .object({
    pspSessionId: yup.string().required(),
    recaptchaToken: yup.string().required(),
    idempotencyKey: yup.string().required(),
    paymentMethod: paymentMethodScheme.required(),
    storePaymentMethod: yup.boolean().optional(),
    pf: bindQuotePayloadSchema
        .concat(yup
        .object()
        .shape({
        financeableTransactions: yup.array().of(financeableTransactionSchema),
    })
        .required())
        .optional()
        .default(undefined),
    padAgreementServiceType: yup
        .mixed()
        .oneOf([PadAgreementServiceType.Personal, PadAgreementServiceType.Commercial])
        .optional(),
    paymentTotal: yup.number().integer().required(),
    convenienceFee: yup.number().integer().required(),
})
    .required();
//# sourceMappingURL=completePayment.js.map